module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/venetian-blind-window/window.mtl";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/venetian-blind-window/window.mtl
// module id = 494
// module chunks = 0